import { useState } from "react";
import useDB from "../../hooks/useDB";
import Loading from "../../components/Loading";
import Error from "../../components/Error";
import DrawContact from "./DrawContact";
import DrawTitles from "./DrawTitles";
import Pagination from "../../components/Pagination";


export default function NewContacts() {


const [contacts, setContacts, error, loading] = useDB(`/marketing-contacts/new`)
const [page,setPage] = useState(0)

if (loading) return <Loading />;
if (error) return <Error />;

    return (
      <div>
        <div>
         <div style={{display:"flex", justifyContent: "space-between"}}>
            Contacts {page*10} - {page*10+10} of {contacts.length} 
            <Pagination
              page={page}
              setPage={setPage}
              end={contacts.length}
            />
          </div>
          <DrawTitles />
        </div>
        <div>
          {contacts.slice(page * 10, page * 10 + 10).map((c) => (
            <DrawContact
              contact={c}
              key={c._id}
            />
          ))}
        </div>
      </div>
    );
}